import React, { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { GoMail } from "react-icons/go";

const TopBar = () => {
  const [showInput, setShowInput] = useState(false);
  return (
    <div
      className="p-2 flex justify-between gap-x-2 items-center px-4 md:px-32 w-full text-gray-400 overflow-hidden"
      style={{ backgroundColor: "#002147" }}
    >
      <div>
        <div className="flex items-center gap-x-1">
          {showInput && (
            <input
              className="border-0 bg-transparent outline-none border-b"
              type="text"
              placeholder="Search.."
            />
          )}
          <BiSearch
            className="text-xl font-bold cursor-pointer"
            onClick={() => setShowInput(!showInput)}
          />
        </div>
      </div>
      <div className="flex">
        <div className="flex items-center gap-x-1">
          <GoMail />
          <p>saintjohnschool@rediffmail.com</p>
        </div>
        <div></div>
      </div>
      <div className="w-1/4"></div>
    </div>
  );
};

export default TopBar;
